import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAccountDashboard } from "../../api/accountDashboardApi";
import { formatDateTime } from "../../components/midpoint/admin/users/adminUserFormatters";

const AccountDashboardPage = () => {
  const [data, setData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const body = await getAccountDashboard();
        if (!cancelled) {
          setData(body.data);
        }
      } catch (error) {
        if (!cancelled) {
          setErrorMessage(error.message || "Unable to load dashboard.");
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (isLoading) {
    return <p className="muted panel-card">Loading dashboard…</p>;
  }

  if (errorMessage) {
    return (
      <section className="panel-card">
        <p className="admin-data-health-error">{errorMessage}</p>
      </section>
    );
  }

  return (
    <>
      <section className="panel-card partner-dashboard-cards">
        <div className="partner-stat-card">
          <span className="muted">Saved searches</span>
          <strong>{data?.savedSearchCount ?? 0}</strong>
          <Link to="/account/saved-searches">View all</Link>
        </div>
        <div className="partner-stat-card">
          <span className="muted">Favorite listings</span>
          <strong>{data?.favoriteListingCount ?? 0}</strong>
          <Link to="/account/favorites">View all</Link>
        </div>
      </section>

      <section className="panel-card">
        <div className="account-security-section__header">
          <h2>Recent saved searches</h2>
          <Link to="/account/saved-searches">Manage</Link>
        </div>
        {(data?.recentSavedSearches || []).length ? (
          <ul className="account-security-history">
            {data.recentSavedSearches.map((search) => (
              <li key={search.savedSearchId}>
                <strong>{search.name}</strong>
                <span className="muted">
                  {search.listingMode || "any"} · {formatDateTime(search.lastUsedAt || search.updatedAt)}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="muted">No saved searches yet. Browse the map and save a search.</p>
        )}
      </section>

      <section className="panel-card">
        <div className="account-security-section__header">
          <h2>Recent favorites</h2>
          <Link to="/account/favorites">Manage</Link>
        </div>
        {(data?.recentFavorites || []).length ? (
          <ul className="account-security-history">
            {data.recentFavorites.map((favorite) => (
              <li key={favorite.favoriteListingId}>
                <strong>{favorite.title || favorite.addressLabel || "Listing"}</strong>
                <span className="muted">{formatDateTime(favorite.createdAt)}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="muted">No favorites yet.</p>
        )}
      </section>

      <section className="panel-card">
        <p className="muted account-security-nav">
          <Link to="/">Browse map &amp; search</Link>
        </p>
      </section>
    </>
  );
};

export default AccountDashboardPage;
